import { useEffect, useState } from "react";
import api from "../lib/api";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

const NONE = "__none__";

const KINDS = {
  company: { url: "/companies", placeholder: "Seleziona azienda", label: (it) => it.legal_name || it.trade_name },
  contact: {
    url: "/contacts", placeholder: "Seleziona contatto",
    label: (it) => `${it.first_name || ""} ${it.last_name || ""}`.trim() + (it.company?.legal_name ? ` · ${it.company.legal_name}` : ""),
  },
  opportunity: { url: "/opportunities", placeholder: "Seleziona opportunità", label: (it) => it.name + (it.company?.legal_name ? ` · ${it.company.legal_name}` : "") },
  lead: { url: "/leads", placeholder: "Seleziona lead", label: (it) => it.title + (it.company_name ? ` · ${it.company_name}` : "") },
  pipeline: { url: "/pipelines", placeholder: "Seleziona pipeline", label: (it) => it.name },
  stage: { url: "/pipelines", placeholder: "Seleziona fase", label: (it) => it.name },
  user: { url: "/auth/users", placeholder: "Seleziona responsabile", label: (it) => `${it.name} · ${it.role_label || it.role}` },
  project: { url: "/projects", placeholder: "Seleziona progetto", label: (it) => it.name + (it.company_name ? ` · ${it.company_name}` : "") },
};

export default function EntitySelect({ kind, value, onChange, companyId, pipelineId }) {
  const [items, setItems] = useState([]);
  const cfg = KINDS[kind] || KINDS.company;

  useEffect(() => {
    api.get(cfg.url).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, [cfg.url]);

  let filtered = items;
  if (kind === "contact" && companyId) filtered = items.filter((i) => i.company_id === companyId);
  if (kind === "opportunity" && companyId) filtered = items.filter((i) => i.company_id === companyId);
  if (kind === "lead" && companyId) filtered = items.filter((i) => i.company_id === companyId);
  if (kind === "stage") {
    const pipe = items.find((p) => p.id === pipelineId) || items[0];
    filtered = pipe?.stages || [];
  }

  return (
    <Select value={value || NONE} onValueChange={(v) => onChange(v === NONE ? null : v)}>
      <SelectTrigger data-testid={`entity-select-${kind}`}>
        <SelectValue placeholder={cfg.placeholder} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={NONE}>—</SelectItem>
        {filtered.map((it) => (
          <SelectItem key={it.id} value={it.id}>{cfg.label(it)}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
